const FETCH_SAMPLE_TUESDAY_DATE =
  "sample_tuesday_date/FETCH_SAMPLE_TUESDAY_DATE_INFO";
const FETCH_SAMPLE_TUESDAY_DATE_SUCCESS =
  "sample_tuesday_date/FETCH_SAMPLE_TUESDAY_DATE_INFO_SUCCESS";
const FETCH_SAMPLE_TUESDAY_DATE_FAIL =
  "sample_tuesday_date/FETCH_SAMPLE_TUESDAY_DATE_INFO_FAIL";

const initialState = {
  pending: true,
  loaded: false,
  sample_tuesday_date: "COMING SOON",
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_SAMPLE_TUESDAY_DATE:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_SAMPLE_TUESDAY_DATE_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        sample_tuesday_date: action.results
      });
    case FETCH_SAMPLE_TUESDAY_DATE_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        error: action.error
      });

    default:
      return state;
  }
}

export function fetchSampleTuesdayDatePending() {
  return {
    type: FETCH_SAMPLE_TUESDAY_DATE
  };
}

export function fetchSampleTuesdayDateSuccess(results) {
  return {
    type: FETCH_SAMPLE_TUESDAY_DATE_SUCCESS,
    results
  };
}

export function fetchSampleTuesdayDateFail(error) {
  return {
    type: FETCH_SAMPLE_TUESDAY_DATE_FAIL,
    error
  };
}

export const getSampleTuesdayDate = state => state.sample_tuesday_date;
